import Vue from 'vue';

if (!localStorage || !window.localStorage || !global.localStorage) {
  Vue.use(import('localstorage-polyfill'));
}
